import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { usePrefetchedSuspenseQuery } from "@-/com.npmjs.tanstack__react-query";
import { morphemeCorpusFilterFromCacheKey } from "@-/dev.improve.haniverse.lib.morpheme.corpus";
import { useMorphemeCorpusFilter } from "@-/dev.improve.haniverse.lib.morpheme.corpus.use";
import {
  getPrimitiveBrowseData,
  type PrimitiveGradingSelection,
} from "@-/dev.improve.haniverse.data.primitive-buckets";

export function useGetBrowsePrimitivesPageQueryKey() {
  const { hanziScript, hskVersion } = useActorUser();
  const [tierScope] = useDeviceSetting("primitivesTierScope");
  const { cacheKey: corpusFilterCacheKey } = useMorphemeCorpusFilter();
  const grading: PrimitiveGradingSelection =
    hanziScript === "traditional"
      ? { script: "traditional", tierScope }
      : { hskVersion, script: "simplified", tierScope };
  // Retire persisted catalogs that displayed dictionary definitions instead of authored glosses.
  return () => ["browsePrimitiveBuckets.v2", grading, corpusFilterCacheKey] as const;
}

export const [useBrowsePrimitivesPageQueryOptions, browsePrimitivesPageQueryFn] =
  createUseQueryOptions(
    useGetBrowsePrimitivesPageQueryKey,
    ({ queryKey: [_, grading, corpusFilterCacheKey] }) =>
      getPrimitiveBrowseData(grading, morphemeCorpusFilterFromCacheKey(corpusFilterCacheKey)),
  );

/** Shared by List and Compounds, using the same prefetched bundled catalog. */
export function useBrowsePrimitivesSuspense() {
  return usePrimitiveBrowseDataSuspense().primitives;
}

export function useBrowsePrimitiveBucketsSuspense() {
  return usePrimitiveBrowseDataSuspense().buckets;
}

function usePrimitiveBrowseDataSuspense() {
  return usePrefetchedSuspenseQuery(useBrowsePrimitivesPageQueryOptions()).data;
}
